import { request } from '@/shared/api/request'

export const getStatusSign = (key) => {
	return request({ url: `contract/mgov/statusSign?&mgovId=${key}`, method: 'GET' })
}
